export default "__VITE_ASSET__Ca7cW7Qj__"